export const apikey = "eb7f19c3";
export const url = "https://www.omdbapi.com/?";
export const options= [
    ["home", "Popular"], 
    ["action", "Action"],
    ["animation","Animation"],
    ["comedy", "Comedy"],
    ["drama", "Drama"],
    ["horror", "Horror"],
    ["scifi", "SciFi"],
    ["thriller", "Thriller"]
];
export const serieslist = {
    action:[
        "Game+of+Thrones"
    ],
    animation:[
        "Attack+on+Titan"
    ],
    comedy:[
        "The+Office"
    ],
    drama: [
        "The+Walking+Dead"
    ],
    horror:[
        "The+Haunting+of+Hill+House"
    ],
    scifi:[
        "Black+Mirror"
    ],
    thriller:[
        "Blue+Bloods"
    ],
    home:[
        "breaking+bad"
    ]
}
export const movielist = {
    action:[
        "Mission+Impossible"
    ],
    animation:[
        "Toy+Story"
    ],
    comedy:[
        "The+Hangover"
    ],
    drama: [
        "1917"
    ],
    horror:[
        "Conjuring"
    ],
    scifi:[
        "Avengers"
    ],
    thriller:[
        "The+Shutter+Island"
    ],
    home:[
        "Star+wars"
    ]
}